import React from 'react';
import PropTypes from 'prop-types';
import Cldr from 'utils/Cldr';
import I18n from 'utils/I18n';
import styles from './index.scss';
import { cartDataProps } from '../../../shared/prop-types';
import { I18nPrefix } from '../../../shared/constants';

const Pricing = ({ isPrimary, label, cartData, showFootnote }) => {
  const amount = isPrimary ? cartData.billedToday : cartData.recurringAmount;
  const formattedAmount = Cldr.formatCurrency(amount, cartData.currency);

  return (
    <div className={styles.container}>
      <h4 className={`${styles.row} ${isPrimary ? 'text-bold' : ''}`}>
        <p>{label}</p>
        <p data-testid="bill-amount">
          {isPrimary
            ? formattedAmount
            : I18n.t(`${I18nPrefix}.summary.students.billing.price_per_year`, {
                price: formattedAmount
              })}
        </p>
      </h4>
      {showFootnote && (
        <small>
          {I18n.t(`${I18nPrefix}.summary.students.billing.cancel_anytime`)}
        </small>
      )}
    </div>
  );
};

Pricing.propTypes = {
  isPrimary: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  cartData: cartDataProps.isRequired,
  showFootnote: PropTypes.bool.isRequired
};

export default Pricing;
